const sourceSites = [
  {
    slug: 'batchmen',
    name: 'Batch Men',
  },
  {
    slug: 'matchesfashion',
    name: 'Matches Fashion',
  },
  {
    slug: 'mrporter',
    name: 'Mr Porter',
  },
  {
    slug: 'endclothing',
    name: 'End Clothing',
  },

  {
    slug: 'uniqlo',
    name: 'Uniqlo',
  },
]

const layerGroups = [
  {
    slug: 'outerwear',
    name: 'Coats & Jackets',
    minimum: 0
  },
  {
    slug: 'midwear',
    name: 'Knitwear & Light Jackets',
    minimum: 0
  },
  {
    slug: 'innerwear',
    name: 'Shirts & T-Shirts',
    minimum: 2
  },
  {
    slug: 'bottoms',
    name: 'Shorts & Trousers',
    minimum: 2
  },
  {
    slug: 'footwear',
    name: 'Footwear',
    minimum: 2
  },
  {
    slug: 'accessories',
    name: 'Accessories',
    subGroups: [
      {
        slug: 'accessories1',
        name: 'Accessories 1',
        minimum: 0
      },
      {
        slug: 'accessories2',
        name: 'Accessories 2',
        minimum: 0
      }
    ]
  }
]

const capsuleCounters = [
  'outfits_count',
  'products_count',
  'votes_count',
  'wear_like_this_images_count'
]

export default {
  install(Vue, opts) {
    Vue.prototype.$constants = Object.freeze({
      SOURCE_SITES: sourceSites,
      LAYER_GROUPS: layerGroups,
      CAPSULE_COUNTERS: capsuleCounters
    });
  }
}



// WEBPACK FOOTER //
// ./src/plugins/Constants/index.js